export enum MainHeaderQASelectors {
    ICON_PROFILE = 'icon-profile',
}